module.exports = __webpack_public_path__ + "img/silent-rides.de80eafc.png";